export const GetAssumptionsList = () => {
    let assumptions = [];
    let storedAssumptions = localStorage.getItem('assumptions');
    if (storedAssumptions != null) {
        assumptions = JSON.parse(storedAssumptions);
        assumptions = assumptions.map((assumption: string) => {
            assumption = assumption.replace("Can you confirm that ", "").replace("?", "");
            assumption = assumption.replace("Can you confirm ", "");
            return Capitalize(assumption);
        })
    }

    return assumptions;
}

export const Capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}